import { AjaxHelper } from "./AjaxHelper";


export class CupuTypesHelper {

    parseCupuTypes(response: any) {
        return AjaxHelper.parseAjaxResponse(response, ["cuputypes"], "HardwareCode");
    }

}